<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field">
          <label class="indam-news p-col-fixed txt-right txt-required">Title</label>
          <div class="p-col">
            <InputText id="name" class="p-inputtext p-col-width pac-target-input ml-0"
              placeholder="Input (max 255 charactors)" v-model="obj_data.name" @input="handleMaxCharacter('name', $event, 255)"/>
          </div>
        </div>
      </div>
       <div class="col-6">
        <div class="p-card-field mt-2">
          <label class="indam-news p-col-fixed txt-right ">Alt</label>
          <div class="p-col">
            <InputText id="alt" class="p-inputtext p-col-width pac-target-input ml-0"
              placeholder="Input (max 255 charactors)" v-model="obj_data.alt" maxlength="255" />
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field mt-2">
          <label class="indam-news p-col-fixed txt-right txt-required">Category</label>
          <div class="p-col">
            <v-select :key="key_type_id" :clearable="false" title="Property" class="" @search="SearchPropertyType"
              placeholder="Choose" v-model="obj_data.news_category_id" :options="listCategory" :reduce="item => item.id"
              label="name">
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="news_category_id">
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field mt-2">
          <label class="indam-news p-col-fixed txt-right txt-required">Short description</label>
          <div class="p-col">
            <Textarea id="short_description" maxLength="2000" rows="2" cols="30" :autoResize="true" class="ml-0"
              v-model="obj_data.short_description" placeholder="Input (max: 2,000 charactors)" @input="handleMaxCharacter('short_description', $event, 2000)" />
          </div>
        </div>
      </div>
     
      <div class="col-12">
        <div class="p-card-field mt-1">
          <label class="indam-news p-col-fixed txt-right txt-required">Description</label>
          <div class="p-col">
            <input class="input_tmp_validator" id="validator_content_description">
            <CkditorCore :contentSet="obj_data.description" @newdata="handleDataCkditor($event, 0, 'description')">
            </CkditorCore>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="p-card-field mt-2">
          <label class="indam-news p-col-fixed txt-right txt-required">Cover Image</label>
          <div class="p-col">
            <div class="cus-text opacity-text-file mt-0 ml-0">Recommended: 800x450px</div>
            <div class="cus-text opacity-text-file mt-0 ml-0">Accepted: JPG, JPEG, PNG, GIF.</div>
            <input class="p-inputtext p-component ml-0 mt-1" accept="image/*" name="images[]" id="images_service"
              type="file" @change="onFileSelectFile" />
            <input class="input_tmp_validator" id="list_file">
            <div class="cus-text style_list_image">
              <div class="box-image" v-for="(item, index) in list_file" :key="index">
                <img class="style_img" :src="item.objectURL" />
                <div class="button-clear" @click="onFileClear(item, index)"><img
                    src="/assets/images/icon/cancel_black_24dp.png" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field mt-2">
          <label class="indam-news p-col-fixed txt-right">Past the URL of a Youtube video</label>
          <div class="p-col">
            <InputText id="url_video" class="p-inputtext p-col-width pac-target-input ml-0"
              placeholder="https://www.youtube.com/…" v-model="obj_data.url_video" />
          </div>
        </div>
      </div>
      <div class="col-12">
        <hr class="mx-2 my-2">
        <div class="pt-2 ml-2"><b style="font-size: 20px;">PRODUCTS</b></div>
      </div>
      <div class="col-6">
        <div class="p-card-field mt-2">
          <label class="p-col-fixed txt-right txt_style_lable">Type of products</label>
          <div class="p-col">
            <div class="type-product-options">
              <div class="custom-control custom-radio">
                <input type="radio" id="type_product_1" name="type_product" class="custom-control-input" value="1"
                  v-model="obj_data.type_product" @change="handleChangeTypeProduct">
                <label class="custom-control-label" for="type_product_1">Availialbe for rent</label>
              </div>
              <div class="custom-control custom-radio mt-1">
                <input type="radio" id="type_product_2" name="type_product" class="custom-control-input" value="2"
                  v-model="obj_data.type_product" @change="handleChangeTypeProduct">
                <label class="custom-control-label" for="type_product_2">Car for sell</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field mt-2">
          <label class="indam-news p-col-fixed txt-right">Products</label>
          <div class="p-col">
            <v-select :key="key_type_id" :clearable="false" title="Property" @search="SearchPropertyType"
              placeholder="Choose" :options="listProductItems" :reduce="item => item" label="text"
              @option:selecting="handleProductItemsSelect">
              <template #selected-option>Choose</template>
              <span slot="no-options" @click="$refs.select.open = true">
                Empty data
              </span>
            </v-select>
          </div>
        </div>
        <div class="car-items ml-3 mt-1">
          <div class="car-item mb-2" v-for="(item, index) in listProductsSelected" :key="index">
            <input type="hidden" name="obj_ids[]" :value="item.id">
            <div class="d-flex justify-content-start align-items-center gap-10">
              <span class="car-item-no text-nowrap">{{ index + 1 }}. </span>
              <div class="car-item-img">
                <div class="bg-img ratio-1-1" :style="{ backgroundImage: 'url(' + item.avatar + ')' }"></div>
              </div>
              <div>[{{ item.code }}]{{ item.text }}</div>
              <div>
                <button type="button" class="btn btn-danger" @click="removeItem(index)">
                  <span class="pi pi-trash p-button-icon"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="p-card-field mt-2">
          <label class="indam-news p-col-fixed txt-right">Order</label>
          <div class="p-col">
            <InputNumber id="ordinal" :class="['ml-0']" v-model="obj_data.ordinal" :min="0" placeholder="0" />
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field div_check mt-2">
          <label class="indam-news p-col-fixed txt-right">Display on</label>
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.website" :binary="true" />
            <label class="p-col-fixed txt-right text">Website</label>
          </div>
          <div class="p-col checkbox pt-0">
            <Checkbox v-model="obj_data.app" :binary="true" />
            <label class="p-col-fixed txt-right text">App</label>
          </div>
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
    </div>
    <CustomCropper
      :key="keyCropper"
      v-if="showCropper"
      :image-src="imageSrc"
      @cropped-image="handleCroppedImage"
      @close="showCropper = false"
    />
  </form>
</template>
<script>
import CkditorCore from '../CkditorCore';
import DataServices from "@/core/DataServices";

export default {
  components: {
    CkditorCore,
  },
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      showCropper: false,
      keyCropper: 0,
      imageSrc: null,
      key_type_id: 1,
      deleteId: null,
      showDeleteDialog: false,
      listDataType: [],
      obj_data: { description: '<p>Type here...</p>' },
      comFilename: 1,
      componentKey: 0,
      list_file: [],
      list_file_edit: [],
      list_id_file_delete: [],
      maxFileSize: 2097152 * 50,
      listCategory: [],
      listProductItems: [],
      listProductsSelected: [],
      listCarForSell: [],
      listPropertyType: [],
      listPropertyTypeAll: [],
      listTypeProduct: [
        {
          id: 1,
          name: "Rent",
        },
        {
          id: 2,
          name: "Sell",
        },
      ],
    }
  },
  async mounted() {
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.$commonFuction.convertJsonObject(this.model);
      this.listProductsSelected = this.obj_data.listProductsSelected ?? [];
      if (!this.$commonFuction.isEmpty(this.model?.list_file_edit)) {
        var list_file_edit = this.model?.list_file_edit
        for (let i = 0; i < list_file_edit.length; i++) {
          var item_file = list_file_edit[i]
          var obj = { id: item_file.id, 'name': '', 'file': '', 'objectURL': item_file.url, type: 'old_edit' }
          this.list_file.push(obj)
        }
      }
      this.componentKey++;
    } else {
      this.obj_data = {
        website: true,
        app: true,
      };
      this.componentKey++;
    }
    await this.getListNewsCategory();
    await this.getListProductItems();
  },
  methods: {
    handleCroppedImage(itemFile) {
       this.list_file=[];
       this.list_file.push(itemFile)
    },
    handleMaxCharacter(field, event, maxLength = 255) {
      let value = event
      if (value.length > maxLength) {
        value = value.slice(0, maxLength)
      }
      this.obj_data[field] = value; 
    },
    handleDataCkditor: function (e, index, key) {
      var dataContent = e;
      if (Array.isArray(dataContent)) {
        dataContent = dataContent.join(' ');
      }
      if (key == 'description') {
        this.obj_data.description = dataContent;
      }
    },
    async onFileSelectFile(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 50) {
        alert("You can only upload a maximum of 50 files at a time");
      } else {
        // Kiểm tra định dạng ảnh
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG'];
        for (let i = 0; i < files.length; i++) {
          const fileExtension = files[i].name.split('.').pop();
          if (!acceptTags.includes(fileExtension)) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            event.target.value = null;
            return;
          }
        }

        // Xóa ảnh cũ nếu có, sử dụng hàm onFileClear
        if (this.list_file.length > 0) {
          this.onFileClear(this.list_file[0], 0);
        }

        // Thêm ảnh mới
        let file = files[0];
        file.source = file;
        file.objectURL = window.URL.createObjectURL(file);
        
        this.list_file.push(file);
        
        // this.showCropper = true;
        // this.imageSrc = URL.createObjectURL(file);
        // this.keyCropper++;

        // Xóa giá trị input để cho phép chọn lại cùng file nếu cần
        event.target.value = null;
      }

    },
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      const fieldsToValidate = [
        { id: "name", value: this.obj_data.name },
        { id: "news_category_id", value: this.obj_data.news_category_id },
        { id: "type_product", value: this.obj_data.type_product },
        { id: "short_description", value: this.obj_data.short_description },
        { id: "validator_content_description", value: this.obj_data.description },
      ];
      let isFormInvalid = false;
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);
        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          } else if (field.id === "name" && field.value.length > 255) {
            inputElement.setCustomValidity("Name must not exceed 255 characters.");
            isFormInvalid = true;
          } else if (field.id === "short_description" && field.value.length > 2000) {
            inputElement.setCustomValidity("Short description must not exceed 2000 characters.");
            isFormInvalid = true;
          } else if (field.minValue !== undefined && field.value <= field.minValue) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          } else {
            inputElement.setCustomValidity("");
          }
        }
      }
      let list_file = document.getElementById("list_file");
      if (this.list_file.length === 0) {
        list_file.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        list_file.reportValidity();
        isFormInvalid = true;
      } else {
        list_file.setCustomValidity("");
      }
      let inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }

      var params = { ...this.obj_data };

      // Các thuộc tính khác
      params.list_file = this.list_file;
      params.list_file_edit = this.list_file_edit;
      params.list_id_file_delete = this.list_id_file_delete;
      params.listProductsSelected = this.listProductsSelected;
      this.$emit('save', params);
    },
    onFileClear(item, index) {
      var type = item?.type ?? null
      if (type == 'old_edit') {
        this.list_id_file_delete.push(item);
      }
      this.list_file.splice(index, 1);
    },
    async getListNewsCategory() {
      var where_key = {
        deleted: { _eq: false },
        type_category: { _eq: 0 },
      }
      var list = await this.$CoreService.getListNewsCategory(where_key);
      this.listCategory = list.list;
    },
    async getListProductItems() {
      const product_type = this.obj_data.type_product;
      if (product_type == 1) {
        await this.getListAvailableRent();
      } else {
        await this.getListCarForSell();
      }
    },
    async getListCarForSell() {
      var gqLQueryList = DataServices.getList('car_for_sell');
      var where = {
        deleted: { _eq: false },
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { created_at: 'desc' }
        }
      });
      var listDataCar = resData.data['car_for_sell'];
      listDataCar = listDataCar.map(item => {
        return {
          id: item.id,
          avatar: 'https://placehold.co/48x48',
          code: item.code,
          text: item.plate_number,
        };
      });
      for (let i = 0; i < listDataCar.length; i++) {
        this.$CoreService.getFile(this.$constants.TYPE_IMAGE.CAR_SELL_AVARTAR, listDataCar[i].id, i).then(dataRes => {
          var list_image = dataRes.listData;
          if (list_image.length > 0) {
            listDataCar[i].avatar = list_image[0].url;
          }
        });
      }
      this.listProductItems = listDataCar;
    },
    async getListAvailableRent() {
      var gqLQueryList = DataServices.getList('available_for_rent');
      var where = {
        deleted: { _eq: false },
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { created_at: 'desc' }
        }
      });
      var listDataAvailable = resData.data['available_for_rent'];
      listDataAvailable = listDataAvailable.map(item => {
        return {
          id: item.id,
          avatar: 'https://placehold.co/48x48',
          code: item.code,
          text: item?.obj_vehicle_category?.name ?? '',
        };
      });
      for (let i = 0; i < listDataAvailable.length; i++) {
        this.$CoreService.getFile(this.$constants.TYPE_IMAGE.CAR_RENT_AVARTAR, listDataAvailable[i].id, i).then(dataRes => {
          var list_image = dataRes.listData;
          if (list_image.length > 0) {
            listDataAvailable[i].avatar = list_image[0].url;
          }
        });
      }
      this.listProductItems = listDataAvailable;
    },
    handleProductItemsSelect(selectedItem) {
      if (this.listProductsSelected.lenght > 0) {
        const exists = this.listProductsSelected.some(item => item.id === selectedItem.id);
        if (!exists) {
          this.listProductsSelected.push(selectedItem);
        }
      } else {
        this.listProductsSelected.push(selectedItem);
      }
    },
    async handleChangeTypeProduct(event) {
      this.listProductsSelected = [];
      this.obj_data.type_product = event.target.value;
      await this.getListProductItems();
    },
    removeItem(index) {
      this.listProductsSelected.splice(index, 1);
    },
    async SearchPropertyType(search, loading) {
      console.log(loading);
      if (search !== '' && search !== null) {
        var where_key = {
          deleted: { _eq: false },
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListNewsCategory(where_key);
        this.listPropertyType = list.list;
      } else {
        this.listPropertyType = this.listPropertyTypeAll
      }
    },
  },
}
</script>
<style lang="scss">
.p-formgrid {
  padding-top: 20px;
}

.p-formgrid .fixed-bottom-toolbar .p-button#back .p-button-label {
  color: #000000 !important;
  font-weight: 500;
}

.p-formgrid .fixed-bottom-toolbar .main-style-button {
  background-color: #ffdf01 !important;
  font-weight: 500;
}

.main-style-button {
  background-color: #0086C4 !important;
}

.opacity-text-file {
  opacity: 0.5;
}

.calendar-css-margin1 {
  padding-right: 0px !important;
}

.calendar-css-margin2 {
  padding-left: 0px !important;
}

.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;
}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 8px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}

.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}


.p-col-fixed {
  padding: 0px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}

.cus-text {
  margin-left: 2px;
  margin-top: 4px;
}

.style-box-phone {
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;

  .p-dropdown {
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }

  .p-focus {
    border: 0px;
    box-shadow: none;
  }

  .p-dropdown:focus {
    border: 0px;
    box-shadow: none;
  }

  input {
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }

  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}

.style_list_image {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;

    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #D0D4D9;
      border-radius: 10px;
    }

    .button-clear {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }
  }
}

.style_box_room {
  display: flex;
}

.style_box_lat_log {
  display: flex;

  .box_lat_log {
    width: 50%;
  }
}

.style_title_group {
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
  text-transform: uppercase;
}

.style_box_price {
  padding-left: 35px !important;
}

.style_rad_button {
  label {
    margin-bottom: 0px;
    margin-left: 15px;
  }
}

.style_btn_add_type {
  width: 60px;
}

.indam-news {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
}

.p-inputtext {
  margin: 0 !important;
}

.type-product-options {
  display: block;
}

.custom-control-label::before {
  border-width: 2px;
  border-color: #333333;
  width: 20px;
  height: 20px;
}

.custom-control-label::after {
  width: 16px;
  height: 16px;
  top: 6.5px;
  left: -22.5px;
}

.custom-control-input:checked~.custom-control-label::before {
  color: #fff;
  border-color: #333333;
  border-width: 2px;
  background-color: #fff;
}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
  background-color: #ffdf01;
  background-image: none;
  border-radius: 50%;
}

.gap-10 {
  gap: 10px;
}

.car-item-img {
  width: 48px;
  height: 48px;
  overflow: hidden;
}

.car-item-no {
  width: 20px;
}

.bg-img {
  background: no-repeat center center scroll;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: relative;
  max-height: 80px;
}

.ratio-1-1 {
  width: 100%;
  position: relative
}

.ratio-1-1 {
  padding-top: 100%
}

</style>
